/**
 * <strong>Purpose:</strong> <br>
 *  Lets the user set Full size widgets like TextArea, ListBox etc. to
 *  a compact size inorder to fit another widget in a column.
 * <br><br>
 *
 * @module MW/toolstrip/mixins/property/CompactMixin
 * @copyright Copyright 2017 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare"
], function(declare){
    return declare(null, {
        _setCompactAttr: function (value) {
            var height = value === true ? 42 : 66;

            if (this.get("height") !== height) {
                this.set("height", height);
            }

            this._set("compact", value);
        }
    });
});